export const DocumentOutline = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.7584 2.26709H4.97497C4.53672 2.26709 4.11643 2.44118 3.80654 2.75107C3.49665 3.06096 3.32256 3.48125 3.32256 3.9195V17.1388C3.32256 17.577 3.49665 17.9973 3.80654 18.3072C4.11643 18.6171 4.53672 18.7912 4.97497 18.7912H14.8894C15.3277 18.7912 15.748 18.6171 16.0579 18.3072C16.3678 17.9973 16.5419 17.577 16.5419 17.1388V8.05053L10.7584 2.26709Z"
        stroke="currentColor"
        strokeWidth="1.39785"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7586 2.26709V8.05053H16.542"
        stroke="currentColor"
        strokeWidth="1.39785"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
